import { Component, OnInit } from '@angular/core';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { FilterStoreKey } from 'src/app/shared/enums/FilterStoreKey';
import { SupportedFormat } from 'src/app/shared/enums/SupportedFormat';
import { IFilterSelection } from 'src/app/shared/interfaces/filter/IFilterSelection';
import { FiltersService } from 'src/app/shared/services/filters/filters.service';
import { MultiStepFormService } from 'src/app/shared/services/modal/multi-step-form/multi-step-form.service';
import { ButtonColorType } from './../../../../enums/ButtonColorType';
import { ButtonType } from './../../../../enums/ButtonType';
import { IButtonGeneratorInput } from './../../../../interfaces/button-generator/IButtonGeneratorInput';

@Component({
    selector: 'app-create-mg-report-step-two',
    templateUrl: './create-mg-report-step-two.component.html',
    styleUrls: ['./create-mg-report-step-two.component.sass']
})
export class CreateMgReportStepTwoComponent implements OnInit {
    widgetsSelected: string[] = [];
    FilterStoreKey = FilterStoreKey;
    supportedFormats: Set<SupportedFormat> = null;
    disableNextButton = true;
    backButton: IButtonGeneratorInput = {
        buttonName: 'Back',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        function: () => {
            this.multiStepFormService.previousStep(this.modalInputData.modalId);
        }
    };
    nextButton: IButtonGeneratorInput = {
        buttonName: 'Next',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        function: this.nextStep.bind(this)
    };

    constructor(
        public modalInputData: ModalInjectedData,
        public multiStepFormService: MultiStepFormService,
        public filtersService: FiltersService
    ) {}

    ngOnInit(): void {
        this.filtersService.filtersPageData.subscribe((res) => {
            if (res) {
                this.disableNextButton = res.get(FilterStoreKey.REPORT_FILTERS)
                    ? false
                    : true;
            }
        });
        const step1Data = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1);
        this.widgetsSelected = step1Data['widgetsSelected'];
        const currentStepData = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(2);
        if (
            this.modalInputData &&
            this.modalInputData.data &&
            this.modalInputData.data['stepData']
        ) {
            const widgetFilters =
                this.modalInputData.data['stepData']['widgetFilters'];
            const filtersMap = new Map(Object.entries(widgetFilters));
            this.filtersService.filtersData.set(
                FilterStoreKey.REPORT_FILTERS,
                filtersMap as Map<string, IFilterSelection>
            );
        }
        // if (currentStepData) {
        // this.filtersService.filtersDataTemp.set(
        //     FilterStoreKey.REPORT_FILTERS,
        //     currentStepData['widgetFilters']
        // );
        // }
    }

    updateData() {
        const filters = this.filtersService.prepareInput(
            Array.from(
                this.filtersService.filtersPageData
                    .getValue()
                    .get(FilterStoreKey.REPORT_FILTERS)
                    .keys()
            ),
            FilterStoreKey.REPORT_FILTERS
        );
        this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .set(2, {
                widgetFilters: new Map(Object.entries(filters)),
                supportedFormats: this.supportedFormats
            });
    }

    nextStep() {
        if (this.disableNextButton) {
            return;
        }
        this.filtersService.convertTempToMain(
            FilterStoreKey.REPORT_FILTERS,
            false
        );
        this.updateData();
        this.multiStepFormService.nextStep(this.modalInputData.modalId);
    }
}
